import React from "react"
import { Container } from "react-bootstrap"

export default function CenteredContainer({ children }) {
  return (
    // <Container
    //   className="d-flex text-justify align-items-center justify-content-center"
    //   style={{ minHeight: "100vh"}}>
    <Container className='centered-cont'>
      {/* <div className='w-100 pt-2 pb-2' style={{ maxWidth: "400px" }}> */}
      <div className='w-100 p-2' style={{ minWidth: "400px" }}>
        {children}
      </div>
    </Container>
  )
}
